export const MemberTestingProgrammeEn = {
    xunjiadang:'Test plan and list',
    kaishishijian:'start time',
    jieshushijian:'End time',
    shushuru:'Please enter scheme name or number',
    sousuo:'search',
    quanxuan:'All select',
    shanshu:'Delete',
    fanyangmingcheng:'Scheme name',
    cangkaozongjiage:'Reference total price',
    shuliang:'Num',
    caozuo:'operation'
}


// WEBPACK FOOTER //
// ./src/lang/member/MemberTestingProgramme/MemberTestingProgrammeEn.js